// extracted by mini-css-extract-plugin
module.exports = {"nav":"_2O_IlQnKZcDw-hZz_4fBDa"};